import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const mainContainer = styled.div`
  width: 691px;
  margin-right: 24px;
  padding-bottom: 120px;

  ${mobile(css`
    width: 100%;
    margin-top: 16px;
    margin-right: 0;
    padding-bottom: 42px;
  `)}

  > p.board-desc {
    margin-left: 8px;
    ${setFontStyle("Body7")};
    color: ${COLOR.grayScale_700};

    ${mobile(css`
      padding: 0 16px 16px 16px;
      margin-left: 0;
    `)}
  }

  > section > ul.board-list {
    padding: 8px 0;

    ${mobile(css`
      padding: 0 8px;
      margin-top: 16px;
    `)}
  }

  > .paging {
    background-color: ${COLOR.white};

    ${mobile(css`
      border-top: 1px solid ${COLOR.grayScale_200};
      padding: 0 16px 64px 16px;
    `)}
  }

  > .paging-video {
    ${mobile(css`
      padding: 0 8px 16px 8px;
      border-bottom: 1px solid ${COLOR.grayScale_200};
    `)}
  }
`;

const boardSection = styled.section`
  margin-bottom: 40px;

  ${mobile(css`
    padding: 24px 8px 16px 8px;
    margin-bottom: 24px;
    background-color: ${COLOR.white};
    border-top: 1px solid ${COLOR.grayScale_200};
    border-bottom: 1px solid ${COLOR.grayScale_200};

    &:last-child {
      margin-bottom: 0;
    }
  `)}

  > h3 {
    margin-bottom: 8px;
  }

  ul li:last-child {
    border-bottom: 0;
  }
`;

const boardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const boardList = styled.ul``;

export default {
  mainContainer,
  boardSection,
  boardHeader,
  boardList,
};
